export type ApiConnexion = ApiResultConnexion | ApiErrorConnexion;

interface ApiResultConnexion {
    data: {
        listId: string;
        brand: string;
    };
}

interface ApiErrorConnexion {
    status: string;
    error: string;
}

export function isResultConnexion(data: any): data is ApiResultConnexion {
    return data.data.listId !== undefined;
}
export function isApiErrorConnexion(data: any): data is ApiErrorConnexion {
    return data.status !== undefined && data.error !== undefined;
}
